import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { content, Lang } from "./content";

const STORAGE_KEY = "medhub-lang";

const readSavedLang = (): Lang => {
  try {
    return localStorage.getItem(STORAGE_KEY) === "en" ? "en" : "ar";
  } catch {
    return "ar";
  }
};

const LangContext = createContext<{ lang: Lang; setLang: (lang: Lang) => void }>({
  lang: "ar",
  setLang: () => {},
});

export const LangProvider = ({ children }: { children: ReactNode }) => {
  const [lang, setLang] = useState<Lang>(readSavedLang);

  useEffect(() => {
    const root = document.documentElement;
    root.lang = lang;
    root.dir = lang === "ar" ? "rtl" : "ltr";
    document.title = content[lang].meta.title;
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute("content", content[lang].meta.description);
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch {}
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang }}>{children}</LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);

export const useContent = () => content[useContext(LangContext).lang];
